export const contentStepsMapping = {
  Offerings: 0,
  Form: 1,
  Result: 2,
};
